//@ts-check
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ContainerContext } from '../../../utils';
import getCcAppsById from '../actions/get-cc-apps-by-id';

/** @param {import('@action-types/ccApp').UseCcAppsByIdOptions} options */
const useCcAppsById = ({ appIds, ...options }) => {
  const { ims } = useContext(ContainerContext);
  const token = ims?.getAccessToken()?.token;
  const enabled = Boolean(token && appIds?.length > 0 && (options.enabled ?? true));

  const data = useQuery({
    queryKey: ['get-cc-apps-by-id', token, appIds],
    queryFn: async ({ signal }) =>
      getCcAppsById({
        appIds,
        token,
        signal,
      }),
    ...options,
    enabled,
  });

  return data;
};

export default useCcAppsById;
